import type { Round } from '@pons/contracts';
import { toCoinView, type CoinView } from './model';
export { safeCoinLink } from './coinIdentityModel';

export const EXPLORE_FILTERS = ['Watching', 'Settled', 'My bets'] as const;
export type ExploreFilter = (typeof EXPLORE_FILTERS)[number];

export function toExploreCoinView(round: Round, now: number): CoinView {
  const coin = toCoinView(round, now);
  if (round.canonical === false) {
    // Keep the user's call, but never present orphaned evidence as a settled win.
    return {
      ...coin,
      phase: round.cancelled ? 'settled' : 'opening',
      outcome: null,
      marketCap: null,
      graduationCap: null,
      changePercent: null,
      resultPercent: null,
      baseline: null,
      history: [],
    };
  }
  return coin;
}

export function exploreCoins(
  market: Round[],
  personal: Round[],
  simulated: CoinView[],
  now: number,
) {
  const byId = new Map(
    market
      .filter((round) => round.canonical !== false)
      .map((round) => [round.id, toExploreCoinView(round, now)]),
  );
  // Personal history is not restricted to the public market's latest 50 rounds.
  for (const round of personal)
    byId.set(round.id, toExploreCoinView(round, now));
  for (const coin of simulated) byId.set(coin.id, coin);
  return [...byId.values()].sort(
    (a, b) => b.start - a.start || a.id.localeCompare(b.id),
  );
}

export function filterExploreCoins(
  coins: CoinView[],
  filter: ExploreFilter,
  now: number,
) {
  return coins.filter((coin) => {
    if (filter === 'My bets') return !!coin.choice;
    const settled =
      !!coin.cancelled || (coin.phase === 'settled' && coin.outcome !== null);
    if (filter === 'Settled') return settled;
    return (
      !settled && now >= coin.closesAt && coin.note !== 'Rechecking chain data'
    );
  });
}
